export default {
  rewards: {
    title: "Hadiah",
    claim: "Klaim",
    weeklyCashback: "Cashback Mingguan",
    weeklyCashbackDesc: "Dapatkan kembali sebagian kerugian mingguan Anda setiap minggu.",
    dailySpin: "Putaran Harian",
    dailySpinDesc: "Putar roda setiap hari untuk berkesempatan memenangkan hadiah besar.",
    invitationBonus: "Bonus Undangan",
    invitationBonusDesc: "Undang teman dan dapatkan hadiah untuk setiap yang bergabung.",
    rebate: "Rebate",
    rebateDesc: "Dapatkan rebate untuk setiap taruhan, menang atau kalah.",
    bannerTitle: "HADIAH",
    bannerSubtitle: "Selesaikan tugas dan dapatkan hadiah luar biasa!",
    sectionTitle: "Hadiah Menakjubkan Anda",
    goNow: "Pergi Sekarang",
    historyReceived: "Total diterima",
    todayReceived: "Diterima hari ini",
    cashbackDialog: {
      title: "Cashback Taruhan",
      loading: "Memuat...",
      empty: "Belum ada aturan cashback",
      level: "Tingkat",
      amountRange: "Rentang Jumlah",
      rewardRate: "Tarif Hadiah",
      rewardCap: "Batas Hadiah",
    },
    cards: {
      checkin: {
        title: "Absensi Harian",
        subtitle: "Masuk untuk absen setiap hari",
        description: "Pemain, jangan lupa absen setiap hari~",
      },
      cashback: {
        title: "Cashback",
        subtitle: "Hadiah rebate platform",
      },
      rescue: {
        title: "Bonus Penyelamat",
        subtitle: "Mainkan 3 game uang asli",
        description: "Dana penyelamat untuk pemain yang bangkrut",
      },
      task: {
        title: "Tugas",
        subtitle: "Selesaikan tugas platform",
        description: "Tugas platform",
      },
      balance: {
        title: "Brankas",
        subtitle: "Dapatkan bunga harian",
        description: "Brankas platform",
      },
      loan: {
        title: "Bonus Pinjaman",
        subtitle: "Pinjam dengan mudah",
        description: "Pinjaman platform",
      },
    },
    checkIn: {
      dailySignIn: "ABSENSI HARIAN",
      totalRewards: "TOTAL HADIAH",
      headlineDaysBefore: "Absen selama",
      headlineDaysAfter: "hari,",
      headlineTailCumulative: "melewatkan sehari tidak masalah.",
      headlineTailDate: "melewatkan sehari akan kehilangan hadiah hari itu.",
      headlineCumulative: "Absen selama {days} hari untuk hadiah besar, melewatkan sehari tidak masalah.",
      headlineDate: "Absen selama {days} hari, melewatkan sehari akan kehilangan hadiah hari itu.",
      headlineEmpty: "Absen untuk mendapatkan hadiah",
      title: "Absensi",
      modeCumulative: "Absensi Kumulatif",
      modeDate: "Absensi Berdasarkan Tanggal",
      rewards: "Hadiah",
      signedIn: "Sudah absen",
      day: "Hari {n}",
      loading: "Memuat...",
      empty: "Tidak ada aktivitas absensi yang aktif.",
      btnCheckIn: "Absen",
      btnSigned: "Sudah Absen",
      btnLocked: "Terkunci",
      claimSuccess: "Absen berhasil, hadiah {amount} {currency} diberikan",
      claimFailed: "Gagal absen",
      alreadySigned: "Anda sudah absen hari ini",
      notLogin: "Silakan masuk terlebih dahulu",
    },
  },
};
